import { z } from 'zod';
/**
 * Hotfix 34 — "IP Whitelisting[TV/PC]" service request. The affected device
 * type is the ticket's Type (subcategory code TV / PC); the MAC address of
 * that device is required. Creating the ticket changes nothing on any
 * firewall, network or device.
 */
export const IP_WHITELISTING_CATEGORY_CODE = 'IP_WHITELISTING';
export const IP_WHITELIST_DEVICE_TYPES = ['TV', 'PC'];
export const IP_WHITELIST_DEVICE_LABEL = 'Affected device type';
export const IP_WHITELIST_MAC_LABEL = 'MAC address of the affected computer/TV';
export const MAC_ADDRESS_ERROR = 'Enter the MAC address as 12 hexadecimal digits, e.g. 00:1A:2B:3C:4D:5E, 00-1A-2B-3C-4D-5E or 001A2B3C4D5E. (This is not the IP address.)';
const MAC_COLON = /^[0-9A-Fa-f]{2}(:[0-9A-Fa-f]{2}){5}$/;
const MAC_HYPHEN = /^[0-9A-Fa-f]{2}(-[0-9A-Fa-f]{2}){5}$/;
const MAC_PLAIN = /^[0-9A-Fa-f]{12}$/;
/**
 * Accepts colon-separated, hyphen-separated or plain 12-hex-digit input
 * (any case, surrounding spaces ignored) and returns the canonical
 * upper-case colon form `AA:BB:CC:DD:EE:FF`, leading zeroes kept. Anything
 * else — an IPv4/IPv6 address, mixed separators, 11 or 13 digits — is null.
 */
export function normaliseMacAddress(raw) {
    if (raw == null)
        return null;
    const s = raw.trim();
    if (!(MAC_COLON.test(s) || MAC_HYPHEN.test(s) || MAC_PLAIN.test(s)))
        return null;
    const hex = s.replace(/[:-]/g, '').toUpperCase();
    return hex.match(/.{2}/g).join(':');
}
export const ipWhitelistDetailsSchema = z
    .object({
    macAddress: z
        .string()
        .trim()
        .max(40)
        .refine((v) => normaliseMacAddress(v) !== null, { message: MAC_ADDRESS_ERROR })
        .transform((v) => normaliseMacAddress(v)),
})
    .strict();
export const ipWhitelistDetailsRecordSchema = z.object({
    deviceType: z.enum(IP_WHITELIST_DEVICE_TYPES),
    macAddress: z.string(),
});
//# sourceMappingURL=ip-whitelist.js.map